import Vue from "vue";
import moment from "moment";
import { zonedTimeToUtc } from "date-fns-tz";
import { format, parse } from "date-fns";
import { en, fr } from "date-fns/locale";
import { env } from "./env";

//TODO: remove moment

export function getTimeZoneTimeStamp(sometime) {
	let dbTime = zonedTimeToUtc(sometime, window.DB_TIMEZONE);

	return dbTime
}

export function betterTime(sometime) {
	let dbTime = zonedTimeToUtc(sometime, window.DB_TIMEZONE);
	let formattedTime = format(dbTime, "dd/MM, HH:mm");

	return formattedTime
}

export function betterTimeWithFormat(sometime, formatString) {
	let dbTime = zonedTimeToUtc(sometime, window.DB_TIMEZONE);

	let currentLang = env.locale.split('-')[0];
	//TODO: make it shared
	let langauges = {'fr':fr, 'en':en}

	let formattedTime = formatString ? format(dbTime, formatString, {locale: langauges[currentLang]}) : dbTime

	return formattedTime
}
export function betterTimeMilliseconds(sometime, format="yyyy-MM-dd HH:mm:ss") {
	const parsedDate = parse(sometime, format, new Date());
	let dbTime = zonedTimeToUtc(parsedDate, window.DB_TIMEZONE);
	return dbTime.getTime();
}

export function betterTimeWithFormatUI(sometime, formatString, currentFormat) {

	if (typeof sometime == 'string') {
		sometime = parse(sometime, currentFormat, new Date());
	}



	let currentLang = env.locale.split('-')[0];
	//TODO: make it shared
	let langauges = {'fr':fr, 'en':en}

	let formattedTime = formatString ? format(sometime, formatString, {locale: langauges[currentLang]}) : dbTime

	return formattedTime
}

export function currency(number, includeSpace = false) {
	const space = includeSpace ? " " : "";
	if(number !== undefined){
		return window.CURRENCY + space + parseFloat(number).toLocaleString(window.LOCALE);
	}
	return window.CURRENCY + space + parseFloat("0").toLocaleString(window.LOCALE);
}

export function millisToMinutesAndSeconds(millis) {
	var minutes = Math.floor(millis / 60000);
	var seconds = ((millis % 60000) / 1000).toFixed(0);
	return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}

export function truncate(somestring, length) {
	return (
		somestring.substring(0, Math.min(length, somestring.length)) +
		(somestring.length >= length ? "..." : "")
	);
}

export function seoText(text) {
	return text
		.split(" ")
		.join("-")
		.toLowerCase();
}

export function toTitleCase(str) {
	if (!str) return str;

	let parts = str.split(" ");
	let full = [];
	parts.forEach((part) => {
		if (part.length <= 2 && parts.length == 1)
			return full.push(part.toUpperCase());
		full.push(
			part.replace(/\w\S*|\/\*/g, function(txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			})
		);
	});
	return full.join(" ");
}

export function formatStringWithTags(string) {
	return string.replace(/<[^>]*>/g, '');
}

export function validatePhoneNumber(phone) {
	const regex = new RegExp(MOBILE_REGEX);
	return regex.test(phone);
}

export function formatPhoneNo(phone) {
	return phone
		.replace(/[^0-9]/g, "")
		.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
}

export function formatNumberWithCommas(number) {
	return parseFloat(number);
}

export function humanTime(dateTime, minsDiff) {
	if (dateTime !== null) {
		let theDateTime = null;

		var now = moment();
		let current = moment(dateTime);

		let timeDateDiff = Math.max(0, current.diff(now, "minutes"));

		if (timeDateDiff < 1) {
			theDateTime = "Started " + current.fromNow();
		} else {
			if (timeDateDiff > minsDiff) {
				//3 hours ahead

				theDateTime = current.calendar(null, {
					sameDay: "[Starts today at] LT",
					nextDay: "[Starts tomorrow at] LT",
					lastDay: "[Ended yesterday at] LT",
					lastWeek: "Ended [on] Do of MMM YYYY [at] LT", //[last] on
					nextWeek: "Starts [on] Do of MMM YYYY [at] LT",
					sameElse: "Starts [on] Do of MMM YYYY [at] LT",
				});
			} else {
				theDateTime = "Starts " + current.fromNow();
			}
		}

		return theDateTime;
	} else {
		return null;
	}
}

export function hyperlinkUrls(text){
	const urlRegex = /\b((https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w\-./?=#%&]*)?)/g;

	// return text.replace(urlRegex, (match, p1) => {
	// 	const hasProtocol = /^https?:\/\//i.test(p1);
	// 	const href = hasProtocol ? p1 : `https://${p1}`;
	// 	return `<a href="${href}" class="user-notifications__message__link" rel="noopener noreferrer">${p1}</a>`;
	// });

	return text.replace(urlRegex, (match) => {
		const hasProtocol = /^https?:\/\//i.test(match);
		const fullUrl = hasProtocol ? match : `https://${match}`;

		const locale = env.locale;

		try {
			const parsed = new URL(fullUrl);

			if (parsed.hostname.indexOf('betika.com') >= 0 || parsed.hostname.indexOf('betika.dev') >= 0) {
				let path = parsed.pathname;

				// Strip /en-ke prefix if present
				// const localePrefix = `/${locale}`
				// if (path.startsWith(localePrefix)) {
				// 	path = path.slice(localePrefix.length);
				// }

				// Ensure leading slash
				if (!path.startsWith('/')) {
					path = '/' + path;
				}

				return `<a class="user-notifications__message__link" href="${path}">${fullUrl}</a>`;
			}

			// Other domains: link and text stay as full URL
			return `<a class="user-notifications__message__link" href="${fullUrl}" target="_blank" rel="noopener noreferrer">${fullUrl}</a>`;
		} catch (e) {
			return match;
		}
	});
}

const RegisterFilters = () => {
	return new Promise((resolve, reject) => {
		Vue.filter("timeZoneTimeStamp", getTimeZoneTimeStamp);
		Vue.filter("time", betterTime);
		Vue.filter("timeFormat", betterTimeWithFormat);
		Vue.filter("timeFormatUI", betterTimeWithFormatUI);
		Vue.filter("timeFormatMilliseconds", betterTimeMilliseconds);
		Vue.filter("currency", currency);
		Vue.filter("truncate", truncate);
		Vue.filter("millisToMinutesAndSeconds", millisToMinutesAndSeconds);
		Vue.filter("toTitleCase", toTitleCase);
		Vue.filter("seoText", seoText);
		Vue.filter("formatPhoneNo", formatPhoneNo);
		Vue.filter("formatNumberWithCommas", formatNumberWithCommas);
		Vue.filter("humanTime", humanTime);
		Vue.filter("formatStringWithTags", formatStringWithTags);
		Vue.filter("hyperlinkUrls", hyperlinkUrls);
		resolve(true);
	});
};

export { RegisterFilters };
